import { Injectable } from '@angular/core';
import { environment } from 'apps/website/src/environments/environment';
import { CryptoService } from '@nexa/encryption';

/**
 * Servicio encargado de administrar los tipos de do
 */
@Injectable()
export class EncryptService {
  /**
   * Servicio encargado de interactuar con el servicio de encriptacion
   */
  private readonly encryptService: CryptoService;

  /**
   * Llave privada
   */
  private readonly key = environment.signingAesKey;

  public constructor(encryptService: CryptoService){
        this.encryptService = encryptService;

  }
  /**
   * Método encargado de encriptar información
   */
  public async toEncrypt(data: string): Promise<string> {
    const encrypted = await this.encryptService.encryptData(this.key, data);
    return encrypted;
  }
  /**
   * Método encargado de desencriptar información
   */
  public async toDecrypt(data: string): Promise<string> {
    const decrypted = await this.encryptService.decryptData(this.key, data);
    return decrypted;
  }
}
